import ButtonIcon from "@mui/icons-material/Add"
import { Button } from "@mui/material"
import React from "react"
import { ButtonProps, Link, useRecordContext } from "react-admin"

export const PropertyUsageAddButton: React.FC<ButtonProps> = (props) => {
  const record = useRecordContext(props)

  return (
    <Button
      color="primary"
      component={Link}
      to={{
        pathname: "/property_usages/create",
      }}
      state={{
        record: {
          booking_id: record.id,
        },
      }}
    >
      <ButtonIcon /> Add property usage
    </Button>
  )
}
